<template>
  <footer class="site-footer">

    <!-- Red contact bar -->
    <div class="footer-topbar">
      <div class="footer-topbar-inner">
        <div class="footer-phone">
          <v-icon color="white" size="16" class="mr-2">mdi-phone</v-icon>
          <strong>Contact Us: 888.818.3088</strong>
        </div>
        <div class="footer-policy-links">
          <router-link to="/privacy-policy">Privacy Policy</router-link>
          <span class="sep">|</span>
          <router-link to="/terms-of-use">Terms of Use</router-link>
        </div>
      </div>
    </div>

    <!-- Main footer (2-column, compact) -->
    <div class="footer-body">
      <div class="footer-body-inner">

        <!-- Column 1: Logo + contact -->
        <div class="footer-col footer-col-contact">
          <img src="@/assets/images/mediumlogo3-dark.png" class="footer-logo" alt="Striglia Enterprises" />

          <div class="contact-row">
            <v-icon color="#5e221d" size="16" class="mr-2 flex-shrink-0">mdi-map-marker</v-icon>
            <span>Palm City, FL 34990</span>
          </div>
          <div class="contact-row">
            <v-icon color="#5e221d" size="16" class="mr-2 flex-shrink-0">mdi-email-outline</v-icon>
            <a href="mailto:info@striglia.net" class="footer-link">info@striglia.net</a>
          </div>
          <div class="contact-row">
            <v-icon color="#5e221d" size="16" class="mr-2 flex-shrink-0">mdi-phone</v-icon>
            <span>888.818.3088</span>
          </div>

          <div class="footer-socials">
            <a
              href="https://www.facebook.com/Striglia-Enterprises-LLC-106461601008373/"
              target="_blank"
              class="social-btn"
              aria-label="Facebook"
            >
              <v-icon size="18">mdi-facebook</v-icon>
            </a>
            <a
              href="https://www.linkedin.com/company/striglia-enterprises-llc/"
              target="_blank"
              class="social-btn"
              aria-label="LinkedIn"
            >
              <v-icon size="18">mdi-linkedin</v-icon>
            </a>
          </div>
        </div>

        <!-- Column 2: Quick links + Partner logos (combined to save space) -->
        <div class="footer-col footer-col-right">
          <div class="footer-right-inner">

            <!-- Quick links -->
            <div class="quick-links-block">
              <div class="footer-heading">Quick Links</div>
              <div class="quick-links-grid">
                <router-link
                  v-for="link in quickLinks"
                  :key="link.title"
                  :to="link.to"
                  class="quick-link"
                >
                  <v-icon size="12" color="#5e221d" class="mr-1">mdi-chevron-right</v-icon>
                  {{ link.title }}
                </router-link>
              </div>
            </div>

            <!-- Logos block -->
            <div class="logos-block">
              <div class="footer-heading">Partners</div>

              <!-- Partner software logos -->
              <div class="logo-row">
                <div class="logo-box logo-provider">
                  <img :src="require('@/assets/images/logos/microsoft-csp.png')" alt="Microsoft Cloud Solution Provider" class="logo-img" />
                </div>
                <div class="logo-box logo-provider">
                  <img :src="require('@/assets/images/logos/ringcentral.png')" alt="RingCentral" class="logo-img" />
                </div>
                <div class="logo-box logo-partner">
                  <img :src="require('@/assets/images/logos/sage.png')" alt="Sage" class="logo-img" />
                </div>
                <div class="logo-box logo-partner logo-no-zoom">
                  <img :src="require('@/assets/images/logos/Logo-Method-blue.png')" alt="Method" class="logo-img" />
                </div>
                <div class="logo-box logo-partner">
                  <img :src="require('@/assets/images/logos/quickbooks.png')" alt="Intuit QuickBooks" class="logo-img" />
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- Bottom bar -->
    <div class="footer-bottom">
      <span>© Copyright 2019, Striglia Enterprises, LLC — All rights reserved.</span>
      <a href="https://striglia.net" class="footer-link" title="IT Heroes">Design and coding by SE</a>
    </div>

  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      quickLinks: [
        { title: 'Home', to: '/' },
        { title: 'Services', to: '/services' },
        { title: 'About Us', to: '/about' },
        { title: 'Support', to: '/support' },
        { title: 'Contact', to: '/contact' }
      ]
    };
  }
};
</script>

<style scoped>
.site-footer { width: 100%; display: block; }

/* ── Top bar ── */
.footer-topbar {
  background: var(--brand-red);
  padding: 11px 0;
}
.footer-topbar-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.footer-phone {
  display: flex;
  align-items: center;
  color: white;
  font-size: 0.92rem;
}
.footer-policy-links {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
}
.footer-policy-links a { color: white; text-decoration: none; }
.footer-policy-links a:hover { text-decoration: underline; }
.sep { color: rgba(255,255,255,0.45); }

/* ── Main body ── */
.footer-body {
  background: #002633;
  padding: 32px 0 28px;
}
.footer-body-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 10px;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

/* Contact column */
.footer-col-contact { flex: 0 0 300px; min-width: 240px; }
.footer-logo {
  height: 54px;
  object-fit: contain;
  display: block;
  margin-bottom: 16px;
}
.contact-row {
  display: flex;
  align-items: center;
  color: #9EADB5;
  font-size: 0.82rem;
  margin-bottom: 8px;
  line-height: 1.4;
}
.contact-row a.footer-link { color: #9EADB5; text-decoration: none; }
.contact-row a.footer-link:hover { color: var(--brand-red); }
.footer-socials {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.social-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(94,34,29,0.15);
  border: 1px solid rgba(94,34,29,0.35);
  color: var(--brand-red);
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.social-btn:hover {
  background: var(--brand-red);
  color: white;
  transform: translateY(-2px);
}

/* Right column */
.footer-col-right { flex: 1; min-width: 280px; }
.footer-right-inner {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}

/* Quick links */
.quick-links-block { flex: 0 0 160px; }
.footer-heading {
  color: white;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 2px solid var(--brand-red);
  display: inline-block;
}
.quick-links-grid {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.quick-link {
  color: #9EADB5;
  font-size: 0.82rem;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: color 0.18s, padding-left 0.18s;
}
.quick-link:hover { color: var(--brand-red); padding-left: 3px; }

/* Logos */
.logos-block { flex: 1; min-width: 340px; }
.logo-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}
/* Outer box: clips the zoomed image */
.logo-box {
  overflow: hidden;
  border-radius: 6px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.logo-partner  { width: 160px; height: 67px; }
.logo-provider { width: 160px; height: 67px; }
.logo-card     { width: 88px;  height: 58px; }
/* Inner image: zoom in to eliminate source-PNG whitespace */
.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform: scale(1.7);
}
.logo-card .logo-img { transform: scale(1.3); }
.logo-no-zoom .logo-img { transform: scale(1.05); padding: 0 6px; }

/* ── Bottom bar ── */
.footer-bottom {
  background: #001820;
  border-top: 1px solid rgba(255,255,255,0.05);
  padding: 11px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  color: #6B8A94;
  font-size: 0.78rem;
  max-width: 100%;
}
.footer-bottom .footer-link {
  color: #6B8A94;
  text-decoration: none;
}
.footer-bottom .footer-link:hover { color: var(--brand-red); }

@media (max-width: 640px) {
  .footer-body-inner { flex-direction: column; gap: 24px; }
  .footer-col-contact { flex: 1; }
  .footer-right-inner { flex-direction: column; gap: 20px; }
  .quick-links-block { flex: 1; }
}
</style>
